import { TrackingRegion } from '../../../common/AnalyticsContext/TrackingData';
import { ButtonGroup } from '../../../common/components/Button/ButtonGroup.styles';
import { ButtonVariants } from '../../../common/components/Button/DeprecatedButtonVariants';
import { StyledLinkButton } from '../../../common/components/Button/StyledButtons';
import { Heading } from '../../../common/components/Typography/Heading/Heading';
import { Paragraph } from '../../../common/components/Typography/Paragraph/Paragraph';
import { Col } from '../../../common/components/layout/FlexLayout';
import {
  HomeInformationCard as FluvaxInformationCard,
  HomeInformationCard as CovidInformationCard,
  CardIcon,
  HomeInformationPageSection,
  HomeInformationRow,
  TrendingBadge,
} from './HomeInformationSection.styles';

export const HomeInformationSection = () => (
  <HomeInformationPageSection trackingRegionId={TrackingRegion.COVID19_INFORMATION}>
    <Heading h2 small>
      Flu vaccine and COVID-19 vaccine information for patients
    </Heading>
    <HomeInformationRow>
      <Col>
        <FluvaxInformationCard
          icon={
            <CardIcon
              src="/public/images/flu_vaccination_20220531095845.svg"
              htmlAttributes={{ alt: 'Flu Vaccination Icon' }}
            />
          }
          title="Flu Vaccinations"
          badge={<TrendingBadge label="Trending" showDescription={false} />}
          footerElements={
            <>
              <ButtonGroup>
                <StyledLinkButton to="/appointments/flu-vaccinations/Australia/NextAvailable?icid=flv:hom:inb::pcs:pha:ctb:::may22">
                  Book a flu vaccination
                </StyledLinkButton>
                <StyledLinkButton
                  to="/flu-vaccine/book-online?icid=flv:hom:inb::pcs:pha:fom:::may22"
                  variant={ButtonVariants.teal}
                  options={{ keyline: true }}
                >
                  Find out more
                </StyledLinkButton>
              </ButtonGroup>
            </>
          }
          compact
          flat
        >
          <Heading h3 small>
            Why should I get the flu vaccination?
          </Heading>
          <Paragraph>
            With flu cases rapidly rising, find out where and why to get vaccinated
          </Paragraph>
        </FluvaxInformationCard>
      </Col>
      <Col>
        <CovidInformationCard
          icon={
            <CardIcon
              src="/public/images/covid_vaccination_20220531095819.svg"
              htmlAttributes={{ alt: 'Covid Vaccination Icon' }}
            />
          }
          title="COVID-19 Vaccinations"
          footerElements={
            <>
              <ButtonGroup>
                <StyledLinkButton to="/appointments/covid--19-vaccinations/Australia/NextAvailable?withFilters=true&icid=cov:hom:inc::paa::bon:::nov21">
                  Book a COVID-19 vaccination
                </StyledLinkButton>
                <StyledLinkButton
                  to="/landing/covid-19-vaccine?icid=cov:hom:inc::paa::fom:::nov21"
                  variant={ButtonVariants.teal}
                  options={{ keyline: true }}
                >
                  Find out more
                </StyledLinkButton>
              </ButtonGroup>
            </>
          }
          compact
          flat
        >
          <Heading h3 small>
            Where can I get my COVID-19 vaccine?
          </Heading>
          <Paragraph>Learn about COVID-19 booster shots, vaccine types and more</Paragraph>
        </CovidInformationCard>
      </Col>
    </HomeInformationRow>
  </HomeInformationPageSection>
);
